import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { LanguageService } from '../../../../../shared/services/language.service';
import { UserService } from '../../../../../shared/services/user.service';
import { ProductionStatusService } from '../../../_api/services/production-status-service';
import { CustomReport2ElementComponent } from '../custom-report2-element/custom-report2-element.component';

let self: CustomReport2ElementDetailsComponent = null;

@Component({
  selector: 'app-custom-report2-element-details',
  templateUrl: './custom-report2-element-details.component.html',
  styleUrls: ['./custom-report2-element-details.component.css']
})
export class CustomReport2ElementDetailsComponent implements OnInit {

  private _showPublicly = false;
  @Input() set showPublicly(v: boolean) {
    this._showPublicly = v;
  }
  get showPublicly() {
    return this._showPublicly;
  }
  @Output() refreshCallbackChanged = new EventEmitter<any>();
  @Input() showTitle = false;

  reportReportElement = null;
  data = null;
  data2 = null;
  maxValueMargin: number = null;
  barChartTitle: string = null;
  lineChartTitle: string = null;

  get highThresholdColor() {
    return CustomReport2ElementComponent.HighThresholdColor;
  }
  get middleThresholdColor() {
    return CustomReport2ElementComponent.MiddleThresholdColor;
  }
  get lowThresholdColor() {
    return CustomReport2ElementComponent.LowThresholdColor;
  }
  highThreshold: number;
  lowThreshold: number;

  private _reportReportElementId: number = null;
  @Input() set reportReportElementId(n: number) {
    this._reportReportElementId = n;
    this.refresh();
  }

  constructor(public ls: LanguageService, public us: UserService, public ds: ProductionStatusService) {
    self = this;
    this.highThreshold = null;
    this.lowThreshold = null
  }

  refresh() {
    let theReport = null;
    self.ds.getCustomReport2details(self._reportReportElementId).toPromise().then((data) => {
      if (data !== null && data.ReportReportElement !== null) {
        theReport = data.ReportReportElement.Report;
        self.reportReportElement = data.ReportReportElement;
        self.data = data.Data;
        self.data2 = Object.assign([], self.data);
        self.data2.reverse();
        self.barChartTitle = `${self.ls.LNG("Label.Lag")} ${self.ls.LNG("Label.yesterday").toLowerCase()}`; //${data.NewestLag.DateFormattedLong}`;
        self.lineChartTitle = `${self.ls.LNG("Label.Lag")} ${data.OldestLag.DateFormattedLong} -> ${data.NewestLag.DateFormattedLong}`;

        self.highThreshold = data.ReportReportElement.MaximumThresholdInDays;
        self.lowThreshold = data.ReportReportElement.MinimumThresholdInDays;

        //Fix the max value to be identical on the value axis (y-axis)
        let minV = self.data[0].LatestLagInDays_MinMaxLimited, maxV = self.data[0].LatestLagInDays_MinMaxLimited;
        for (let i = 1; i < self.data.length; i++) {
          const v = self.data[i].LatestLagInDays_MinMaxLimited;
          if (v > maxV) {
            maxV = v;
          }
          else if (v < minV) {
            minV = v;
          }
        }
        self.maxValueMargin = (self.reportReportElement.MaximumValueInDays - maxV) / (maxV - minV);
      }
    }).catch((reason) => {
      theReport = null;
      notify("an error occurred:" + reason, "error", 3000);
    }).finally(() => {
      if (self._showPublicly) {
        self.refreshCallbackChanged.emit({
          sleepTimeInMilliSeconds: theReport !== null ? theReport.RefreshIntervalInMinutes * 60000 : 15 * 60000,//if the data retrieval failed wait 15 minutes before trying again
          refreshFunction: self.refresh
        });
      }
    });
  }

  customizePieChartLabel(arg) {
    return arg.value.toFixed(1);
  }

  ngOnInit() {
  }

  barChartCustomizeLabel(arg: any)  {
    const theLag = arg.data.LatestLagInDays;
    return {
      visible: true,
      customizeText: function (ee) {
        return theLag !== null ? theLag.toFixed(1) : "";
      }
    };
  }

}
